import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

const QuickMoveModal = ({ movingItem, activeTab, categoriesBySection, onMove, onClose }) => {
  return (
    <AnimatePresence>
      {movingItem && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="bg-white rounded-2xl shadow-xl w-full max-w-md max-h-[80vh] overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-4 border-b flex items-center justify-between">
              <div>
                <h3 className="text-lg font-bold text-slate-800">Move {activeTab === 'videos' ? 'Video' : 'Image'}</h3>
                <p className="text-sm text-slate-500 truncate">{movingItem.title}</p>
              </div>
              <button onClick={onClose} className="p-2 text-slate-400 hover:text-slate-600 rounded-lg">
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <div className="p-4 max-h-96 overflow-y-auto">
              {Object.entries(categoriesBySection).map(([section, cats]) => (
                <div key={section} className="mb-4">
                  <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-2">{section}</p>
                  <div className="space-y-1">
                    {cats.map(cat => (
                      <button
                        key={cat.value}
                        onClick={() => onMove(movingItem, cat.value)}
                        disabled={movingItem.category === cat.value}
                        className={`w-full text-left px-3 py-2 rounded-lg text-sm ${
                          movingItem.category === cat.value
                            ? 'bg-blue-100 text-blue-700 font-medium'
                            : 'text-slate-600 hover:bg-slate-100'
                        }`}
                      >
                        {cat.label}
                        {movingItem.category === cat.value && <span className="ml-2 text-xs">(current)</span>}
                      </button>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default QuickMoveModal;
